_ = require("lodash")
moment = require("moment")

AnalysisEventService = ($http, $q, ScoreCardAPIService, $routeParams) ->

  getUserInfo: ->
    id = $routeParams.user_id
    $http.get("/api/settings/account.json?user_id=#{id}")

  getScoreCards: ->
    id = $routeParams.user_id
    $http.get("/api/users/#{id}/score_cards.json")

  getEvent: ->
    event_id = $routeParams.id
    $http.get("/api/group_events/#{event_id}.json")

  getMyAnalysis: (options={}) ->
    id = $routeParams.user_id
    event_id = $routeParams.id
    params = _.pickBy
      event_id: $routeParams.id
      round_type: '0.5,1,1.5'
    , (v) -> v != null && v != undefined

    promises =
      best_worst: ScoreCardAPIService.getBestWorst(id,params)
      my_avg: ScoreCardAPIService.getMyAvg(id,params)

    defer = $q.defer()
    $q.all(promises).then (result) ->
      defer.resolve
        my_avg: result.my_avg.data
        best_score: result.best_worst.data.best_score
        worst_score: result.best_worst.data.worst_score
    defer.promise

AnalysisEventService.$inject = [
  '$http'
  '$q'
  'ScoreCardAPIService'
  '$routeParams'
]

module.exports = AnalysisEventService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/analysis-service.coffee